import { render, staticRenderFns } from "./SponsorCategoryList.vue?vue&type=template&id=2c0c70e4"
import script from "./SponsorCategoryList.vue?vue&type=script&lang=js"
export * from "./SponsorCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports